<template>
  <footer>
    <div class="container-right footer">
      <div class="container-fluid">
        <div class="row px-dynamic d-flex flex-row">
          <div class="spacer-40" />
          <div class="footer-block ml-md-auto">
            <ul>
              <li class="show-desktop">
                <i class="fa fa-phone-alt"></i> +7(473)260-60-60
              </li>
              <li class="show-mobile">
                <a href="tel:+7(473)260-60-60"
                  ><i class="fa fa-phone-alt"></i> +7(473)260-60-60</a
                >
              </li>
              <li>
                <i class="fa fa-envelope"></i> 394030, <span class="no-wrap">г. Воронеж</span>
              </li>
              <li><span class="no-wrap">ул. Плехановская, 22а</span></li>
              <li><span class="no-wrap">© АО ИК "Информсвязь-Черноземье"</span></li>
              <li><span class="no-wrap">1992 – {{ currentYear }}</span></li>
              <li>
                <a
                  class="mr-2 link-ext"
                  data-link-ext="VK"
                  href="https://vk.com/freedomvrn"
                  target="_blank"
                  ><i class="fab fa-vk"></i
                ></a>
                <a
                  class="mr-2 link-ext"
                  data-link-ext="TG"
                  href="https://t.me/FreedomConversationBot"
                  target="_blank"
                  ><i class="fab fa-telegram-plane"></i
                ></a>
              </li>
            </ul>
          </div>
          <div class="spacer-75"></div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};

</script>

<style scoped>
.no-wrap {
  white-space: nowrap;
}
</style>